import { Controller } from "@hotwired/stimulus"

const TABLET_VIEW_MIN_WIDTH = 520

export default class extends Controller {
  connect() {
    const mql = window.matchMedia(`(min-width: ${ TABLET_VIEW_MIN_WIDTH }px)`)

    mql.addEventListener('change', this.#onChange)
    this.#onChange(mql)
  }

  #onChange = e => {
    if (e.matches) {
      this.element.removeAttribute('data-mobile-view')
    } else {
      this.element.setAttribute('data-mobile-view', '')
    }

    this.dispatch('change')
  }
}
